import {
  Flex,
  PanelHeader,
  PanelLayout,
  PanelSidebar,
  Sidebar,
  SidebarItem,
  Typography,
  ThemeChanger,
  Tag,
} from "djuno-design";
import { ReactComponent as Logo } from "./../assets/icons/logo.svg";
import { ReactComponent as DjunoIoLogo } from "./../assets/icons/djunoio.svg";
import { ReactComponent as GithubIcon } from "./../assets/icons/github.svg";
import { ReactComponent as NpmIcon } from "./../assets/icons/npm.svg";
import { ReactComponent as CodeBracketIcon } from "./../assets/icons/code-bracket.svg";
import { ReactComponent as CubeIcon } from "./../assets/icons/cube.svg";
import { ReactComponent as LinkIcon } from "./../assets/icons/link.svg";
import { ReactComponent as FireIcon } from "./../assets/icons/fire.svg";
import { ReactComponent as WrenchIcon } from "./../assets/icons/wrench-screwdriver.svg";
import { ReactComponent as BlogIcon } from "./../assets/icons/book-open.svg";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  accordionPageUrl,
  alertPageUrl,
  buttonPageUrl,
  dividerPageUrl,
  dropdownPageUrl,
  emptyStatePageUrl,
  checkboxPageUrl,
  homePageUrl,
  inputPageUrl,
  loadingPageUrl,
  modalPageUrl,
  popoverPageUrl,
  paginationPageUrl,
  panelLayoutsPageUrl,
  secureCopyPageUrl,
  selectPageUrl,
  sidebarPageUrl,
  skeletonPageUrl,
  stepsPageUrl,
  switcherPageUrl,
  textareaPageUrl,
  tooltipPageUrl,
  typographyPageUrl,
  tabsPageUrl,
  cardPageUrl,
  flexPageUrl,
  simpleTablePageUrl,
  ddpPageUrl,
  jsonViewerPageUrl,
  themeChangersPageUrl,
  overviewPageUrl,
  tabsWithUrlPageUrl,
  codeViewerPageUrl,
  installationPageUrl,
  DjunoUrl,
  GithubUrl,
  utilitiesPageUrl,
  hooksPageUrl,
  useDjunoDesignPageUrl,
  useShowPageUrl,
  useWindowOnClickPageUrl,
  NpmPackageUrl,
  TagPageUrl,
  formPageUrl,
  blogsPageUrl,
  copyableUrl,
  // overviewPageUrl,
} from "./../urls";
import { useCallback, useMemo } from "react";
import packageJson from "./../../package.json";
const { Text } = Typography;

const DocsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSidebarNavigation = useCallback(
    (item: SidebarItem | undefined) => {
      const route = `${item?.link}`;
      navigate(route);
    },
    [navigate]
  );

  const sidebarItems: SidebarItem[] = useMemo(() => {
    return [
      // {
      //   id: 0,
      //   label: "Overview",
      //   activeConditions: [{
      //     index: 0,
      //     value: "components",
      //   },
      //   link: overviewPageUrl,
      //   onClick: handleSidebarNavigation,
      // },
      {
        id: "install",
        label: "Installation Guide",
        icon: CodeBracketIcon,
        activeConditions: [
          {
            index: 1,
            value: "install",
          },
        ],
        link: installationPageUrl,
        onClick: handleSidebarNavigation,
      },
      {
        id: "ddp",
        label: "DjunoDesignProvider",
        icon: FireIcon,
        activeConditions: [
          {
            index: 1,
            value: "ddp",
          },
        ],
        link: ddpPageUrl,
        onClick: handleSidebarNavigation,
      },
      {
        id: "components",
        label: ({ isActive }) => (
          <div className="flex w-full items-center justify-between">
            Components
            <Typography.Text
              size="xs"
              uiType={isActive ? "transparent" : "success"}
              className="!w-auto"
            >
              +30
            </Typography.Text>
          </div>
        ),
        icon: CubeIcon,
        activeConditions: [
          {
            index: 1,
            value: "components",
          },
          {
            index: 2,
            value: undefined,
          },
        ],
        link: overviewPageUrl,
        onClick: handleSidebarNavigation,
        children: [
          // {
          //   id: "components-overview",
          //   label: "Overview",
          //   activeConditions: [
          //     {
          //       index: 2,
          //       value: "overview",
          //     },
          //   ],
          //   link: overviewPageUrl,
          //   onClick: handleSidebarNavigation,
          // },
          {
            id: "form",
            label: "Form components",
            activeConditions: [
              {
                index: 2,
                value: "form",
              },
              {
                index: 3,
                value: undefined,
              },
            ],
            link: formPageUrl,
            onClick: handleSidebarNavigation,
            children: [
              {
                id: "checkbox",
                label: "Checkbox",
                activeConditions: [
                  {
                    index: 3,
                    value: "checkbox",
                  },
                ],
                link: checkboxPageUrl,
                onClick: handleSidebarNavigation,
              },
              {
                id: "input",
                label: "Input",
                activeConditions: [
                  {
                    index: 3,
                    value: "input",
                  },
                ],
                link: inputPageUrl,
                onClick: handleSidebarNavigation,
              },
              {
                id: "textarea",
                label: "Textarea",
                activeConditions: [
                  {
                    index: 3,
                    value: "textarea",
                  },
                ],
                link: textareaPageUrl,
                onClick: handleSidebarNavigation,
              },
              {
                id: "select",
                label: "Select",
                activeConditions: [
                  {
                    index: 3,
                    value: "select",
                  },
                ],
                link: selectPageUrl,
                onClick: handleSidebarNavigation,
              },
              {
                id: "switcher",
                label: "Switcher",
                activeConditions: [
                  {
                    index: 3,
                    value: "switcher",
                  },
                ],
                link: switcherPageUrl,
                onClick: handleSidebarNavigation,
              },
            ],
          },
          {
            id: "accordion",
            label: "Accordion",
            activeConditions: [
              {
                index: 2,
                value: "accordion",
              },
            ],
            link: accordionPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "alert",
            label: "Alert",
            activeConditions: [
              {
                index: 2,
                value: "alert",
              },
            ],
            link: alertPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "button",
            label: "Button",
            activeConditions: [
              {
                index: 2,
                value: "button",
              },
            ],
            link: buttonPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "card",
            label: "Card",
            activeConditions: [
              {
                index: 2,
                value: "card",
              },
            ],
            link: cardPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "code-viewer",
            label: "CodeViewer",
            activeConditions: [
              {
                index: 2,
                value: "code-viewer",
              },
            ],
            link: codeViewerPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "divider",
            label: "Divider",
            activeConditions: [
              {
                index: 2,
                value: "divider",
              },
            ],
            link: dividerPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "dropdown",
            label: "Dropdown",
            activeConditions: [
              {
                index: 2,
                value: "dropdown",
              },
            ],
            link: dropdownPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "emptyState",
            label: "EmptyState",
            activeConditions: [
              {
                index: 2,
                value: "empty-state",
              },
            ],
            link: emptyStatePageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "flex",
            label: "Flex",
            activeConditions: [
              {
                index: 2,
                value: "flex",
              },
            ],
            link: flexPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "json-viewer",
            label: "JsonViewer",
            activeConditions: [
              {
                index: 2,
                value: "json-viewer",
              },
            ],
            link: jsonViewerPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "loading",
            label: "Loading",
            activeConditions: [
              {
                index: 2,
                value: "loading",
              },
            ],
            link: loadingPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "modal",
            label: "Modal",
            activeConditions: [
              {
                index: 2,
                value: "modal",
              },
            ],
            link: modalPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "pagination",
            label: "Pagination",
            activeConditions: [
              {
                index: 2,
                value: "pagination",
              },
            ],
            link: paginationPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "panel-layouts",
            label: "Panel Layouts",
            activeConditions: [
              {
                index: 2,
                value: "panel-layouts",
              },
            ],
            link: panelLayoutsPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "popover",
            label: "Popover",
            activeConditions: [
              {
                index: 2,
                value: "popover",
              },
            ],
            link: popoverPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "secureCopy",
            label: "SecureCopy",
            activeConditions: [
              {
                index: 2,
                value: "secure-copy",
              },
            ],
            link: secureCopyPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "sidebar",
            label: "Sidebar",
            activeConditions: [
              {
                index: 2,
                value: "sidebar",
              },
            ],
            link: sidebarPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "simple-table",
            label: "SimpleTable",
            activeConditions: [
              {
                index: 2,
                value: "simple-table",
              },
            ],
            link: simpleTablePageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "skeleton",
            label: "Skeleton",
            activeConditions: [
              {
                index: 2,
                value: "skeleton",
              },
            ],
            link: skeletonPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "steps",
            label: "Steps",
            activeConditions: [
              {
                index: 2,
                value: "steps",
              },
            ],
            link: stepsPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "tabs",
            label: "Tabs",
            activeConditions: [
              {
                index: 2,
                value: "tabs",
              },
            ],
            link: tabsPageUrl,
            onClick: handleSidebarNavigation,
            children: [
              {
                id: "tabs-support-url",
                label: "Tabs support url",
                activeConditions: [
                  {
                    index: 3,
                    value: "tabs-support-url",
                  },
                ],
                link: tabsWithUrlPageUrl,
                onClick: handleSidebarNavigation,
              },
            ],
          },
          {
            id: "tag",
            label: "Tag",
            activeConditions: [
              {
                index: 2,
                value: "tag",
              },
            ],
            link: TagPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "theme-changer",
            label: "ThemeChanger",
            activeConditions: [
              {
                index: 2,
                value: "theme-changers",
              },
            ],
            link: themeChangersPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "tooltip",
            label: "Tooltip",
            activeConditions: [
              {
                index: 2,
                value: "tooltip",
              },
            ],
            link: tooltipPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "typography",
            label: "Typography",
            activeConditions: [
              {
                index: 2,
                value: "typography",
              },
            ],
            link: typographyPageUrl,
            onClick: handleSidebarNavigation,
          },
        ],
      },
      {
        id: "hooks",
        label: "Hooks",
        icon: LinkIcon,
        activeConditions: [
          {
            index: 1,
            value: "hooks",
          },
          {
            index: 2,
            value: undefined,
          },
        ],
        link: hooksPageUrl,
        onClick: handleSidebarNavigation,
        children: [
          {
            id: "use-djuno-design",
            label: "useDjunoDesign",
            activeConditions: [
              {
                index: 2,
                value: "use-djuno-design",
              },
            ],
            link: useDjunoDesignPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "use-show",
            label: "useShow",
            activeConditions: [
              {
                index: 2,
                value: "use-show",
              },
            ],
            link: useShowPageUrl,
            onClick: handleSidebarNavigation,
          },
          {
            id: "use-window-on-click",
            label: "useWindowOnClick",
            activeConditions: [
              {
                index: 2,
                value: "use-window-on-click",
              },
            ],
            link: useWindowOnClickPageUrl,
            onClick: handleSidebarNavigation,
          },
        ],
      },
      {
        id: "utilities",
        label: "Utilities",
        icon: WrenchIcon,
        activeConditions: [
          {
            index: 1,
            value: "utilities",
          },
        ],
        link: utilitiesPageUrl,
        onClick: handleSidebarNavigation,
      },
      {
        id: "blogs",
        label: "blogs",
        icon: BlogIcon,
        activeConditions: [
          {
            index: 1,
            value: "blogs",
          },
          {
            index: 2,
            value: undefined,
          },
        ],
        link: blogsPageUrl,
        onClick: handleSidebarNavigation,
        children: [
          {
            id: "copyable",
            label: "copyable",
            activeConditions: [
              {
                index: 2,
                value: "copyable",
              },
            ],
            link: copyableUrl,
            onClick: handleSidebarNavigation,
          },
        ],
      },
    ];
  }, [handleSidebarNavigation]);

  const sidebarSubItems: SidebarItem[] = useMemo(() => {
    return [
      {
        id: "djuno",
        label: "Djuno Ltd",
        icon: DjunoIoLogo,
        link: DjunoUrl,
        onClick: (item) => {
          if (item && item.link) window.open(item.link, "_blank");
        },
      },
      {
        id: "github",
        label: "Github page",
        icon: GithubIcon,
        link: GithubUrl,
        onClick: (item) => {
          if (item && item.link) window.open(item.link, "_blank");
        },
      },
      {
        id: "npm",
        label: "NPM page",
        icon: NpmIcon,
        link: NpmPackageUrl,
        onClick: (item) => {
          if (item && item.link) window.open(item.link, "_blank");
        },
      },
    ] as SidebarItem[];
  }, []);

  return (
    <div className="h-screen w-screen bg-blue-50/50 dark:bg-[#1D2125]">
      <PanelLayout
        type="normal"
        pathname={location.pathname}
        // className=""
        renderSidebar={({ segments, ...sidebarProps }) => {
          // console.log(segments);
          return (
            <PanelSidebar
              {...sidebarProps}
              sidebarHeader={
                <Link to={homePageUrl} className="flex items-center gap-1 px-5">
                  <Logo className="text-[#0074E4] w-[25px] h-[25px]" />
                  <Text size="lg" strong>
                    Djuno Design 📖
                  </Text>
                </Link>
              }
            >
              <Sidebar
                type="normal"
                items={sidebarItems}
                segments={segments}
                subItems={sidebarSubItems}
                navItemHeight={38}
              >
                <Flex justify="center"></Flex>
              </Sidebar>
            </PanelSidebar>
          );
        }}
        renderHeader={(headerProps) => (
          <PanelHeader
            {...headerProps}
            mobileIcon={<Logo className="w-[25px] h-[25px] text-[#0074E4]" />}
          >
            <Flex
              justify="between"
              items="center"
              className="w-full pl-3 md:pl-0"
            >
              <Flex items="center" className="gap-2">
                <Text size="sm">Current version:</Text>
                <Tag>{packageJson.dependencies["djuno-design"].slice(1)}</Tag>
              </Flex>

              <Flex className="gap-3">
                <ThemeChanger anchor="top end" />
                <Typography.Link strong target="_blank" href={GithubUrl}>
                  <GithubIcon className="w-6 h-6 text-slate-600 hover:text-slate-700 dark:text-slate-300 dark:hover:text-slate-200 hover:scale-105" />
                </Typography.Link>
              </Flex>
            </Flex>
          </PanelHeader>
        )}
        enableGoToTopAfterScroll={true}
        enableGoToTopAfterChangeRoute={true}
      >
        <div
          className="max-w-7xl mx-auto p-4 md:!p-5 lg:!p-8"
          id="main-container"
        >
          <Outlet />
        </div>
      </PanelLayout>
    </div>
  );
};

export default DocsLayout;
